
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser } from 'react-icons/fa';
import logo from '../assets/logo.svg'; 

const Navbar = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const navigateToHome = () => navigate('/');

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
      <div className="flex items-center justify-between p-4">
        <button 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="text-gray-800 focus:outline-none lg:hidden"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <div className="flex-grow flex items-center justify-center lg:justify-start">
          <img
            src={logo}
            alt="Logo"
            className="h-12 cursor-pointer"
            onClick={navigateToHome}
          />
        </div>

     
      </div>
    </header>
  );

};

export default Navbar;
